// src/contexts/AlbumContext.js
import React, { createContext, useState, useEffect } from 'react';

// Criar o contexto
export const AlbumContext = createContext();

// Provedor do contexto
export const AlbumProvider = ({ children }) => {
    // Estado para armazenar as imagens selecionadas para o álbum
    const [selectedImages, setSelectedImages] = useState([]);
    // Estado para armazenar o título do álbum
    const [albumTitle, setAlbumTitle] = useState('');
    // Estado para armazenar o estilo da capa
    const [coverStyle, setCoverStyle] = useState('infantil');
    // Estado para armazenar o tamanho do papel
    const [paperSize, setPaperSize] = useState('A4');
    // Estado para armazenar a orientação do papel
    const [orientation, setOrientation] = useState('portrait');
    // Estado para armazenar o layout das páginas
    const [pageLayout, setPageLayout] = useState('one_per_page');
    // Estado para armazenar a dedicatória
    const [dedication, setDedication] = useState('');

    // Carregar do localStorage na inicialização
    useEffect(() => {
        try {
            // Carregar imagens selecionadas
            const storedImages = localStorage.getItem('albumImages');
            if (storedImages) {
                setSelectedImages(JSON.parse(storedImages));
            }

            // Carregar configurações do álbum
            const storedSettings = localStorage.getItem('albumSettings');
            if (storedSettings) {
                const settings = JSON.parse(storedSettings);
                setAlbumTitle(settings.title || '');
                setCoverStyle(settings.coverStyle || 'infantil');
                setPaperSize(settings.paperSize || 'A4');
                setOrientation(settings.orientation || 'portrait');
                setPageLayout(settings.pageLayout || 'one_per_page');
                setDedication(settings.dedication || '');
            }
        } catch (error) {
            console.error('Erro ao carregar dados do localStorage:', error);
        }
    }, []);

    // Salvar no localStorage quando o estado muda
    useEffect(() => {
        localStorage.setItem('albumImages', JSON.stringify(selectedImages));
        
        localStorage.setItem('albumSettings', JSON.stringify({
            title: albumTitle,
            coverStyle,
            paperSize,
            orientation,
            pageLayout,
            dedication
        }));
    }, [selectedImages, albumTitle, coverStyle, paperSize, orientation, pageLayout, dedication]);

    // Adicionar uma imagem ao álbum
    const addImage = (image) => {
        // Verificar se a imagem já existe no álbum
        if (!selectedImages.some(img => img.id === image.id)) {
            setSelectedImages([...selectedImages, image]);
            return true;
        }
        return false;
    };

    // Remover uma imagem do álbum
    const removeImage = (imageId) => {
        setSelectedImages(selectedImages.filter(img => img.id !== imageId));
    };

    // Reordenar as imagens do álbum
    const reorderImages = (newOrder) => {
        setSelectedImages(newOrder);
    };

    // Limpar o álbum
    const clearAlbum = () => {
        setSelectedImages([]);
        setAlbumTitle('');
        setCoverStyle('infantil');
        setDedication('');
        // Manter as preferências de papel e layout
    };

    // Definir o valor do contexto
    const value = {
        selectedImages,
        albumTitle,
        coverStyle,
        paperSize,
        orientation,
        pageLayout,
        dedication,
        addImage,
        removeImage,
        reorderImages,
        clearAlbum,
        setAlbumTitle,
        setCoverStyle,
        setPaperSize,
        setOrientation,
        setPageLayout,
        setDedication
    };

    return (
        <AlbumContext.Provider value={value}>
            {children}
        </AlbumContext.Provider>
    );
};

export default AlbumProvider;